import React from 'react';
import { Outlet } from 'react-router-dom';

import { ILayoutProps } from './type';

export interface INoLayoutProps extends ILayoutProps {}

const NoLayout = ({ children }: INoLayoutProps): JSX.Element => {
  return <>{children ?? <Outlet />}</>;
};

export default NoLayout;
